(ns manatee.sysadmin.view
  (:require
   [kee-frame.core :as kf]
   [manatee.admin.view :as admin-view]
   [manatee.sysadmin.import-subs :as i-su]
   [manatee.sysadmin.import-tasks :as i-tc]
   [manatee.ui.templates :as templates]
   [manatee.user.subs :as user-subs]
   [re-frame.core :as rf]
   [rothko.nav.component :refer [nav]]))

(def pages [[:import-task-config {:title "Import Task Config", :view i-tc/view}]
            [:import-submissions {:title "Import Submissions", :view i-su/view}]])

(defn coerce-page
  [tab]
  (let [tab-keys (map first pages)]
    (or (get (set tab-keys) (keyword tab))
        (first tab-keys))))

(defn tabs
  [active-tab]
  [nav {:appearance #{:horizontal}
        :menu-toggle-handler #()
        :items (->> pages
                    (map (fn [[key data]]
                           (assoc data
                                  :key key
                                  :selected? (= active-tab key)
                                  :route [key]))))
        :route-handler (fn [[tab-key]] (kf/path-for [:manatee.sysadmin.handlers/main {:query-params {:tab (name tab-key)}}]))}])

(defn view
  [props]
  (let [admin? @(rf/subscribe [::user-subs/admin?])]
    (if-not admin?
      [admin-view/access-denied props]
      (into [kf/switch-route (fn [{{:keys [tab]} :query}] (coerce-page tab))
             nil [:div {} [tabs] [:<> [:span "Page does not exist!"]]]]
            (->> pages
                 (map (fn [[key {view-fn :view}]]
                        [key [:div {}
                              [tabs key]
                              [view-fn]]]))
                 (apply concat))))))

(def main-page {:main view :template templates/single-column})
